import { generatePass } from "../../../utils/ZoomSessionSupport";

export function appointmentEncounterPayload({ appointment, source, organizationRef, practitionerRef }) {
  const booking = appointment.bookingContext;
  const patientRef = appointment.patients?.find(patient => patient.role === "subject")?.patientRef || appointment.patientRefs?.[0];
  if (!booking?.sourceEncounterId || source?.id !== booking.sourceEncounterId || source.orgId !== organizationRef || source.serviceProvider?.reference !== `Organization/${organizationRef}` || source.subject?.reference !== `Patient/${patientRef}`) {
    throw new Error("The source encounter does not match this appointment.");
  }
  if (!practitionerRef || !appointment.practitionerRefs?.includes(practitionerRef)) throw new Error("Only an assigned practitioner can launch this appointment.");
  const { questionnaireResponseId, zoomTopic, zoomPassword, ...intake } = source.intakeQuestions || {};
  const startedAt = new Date().toISOString();
  const actor = { reference: `Practitioner/${practitionerRef}`, type: "Practitioner" };
  const payload = {
    appointmentId: appointment.appointmentId,
    sourceEncounterId: source.id,
    sourceQuestionnaireResponseId: questionnaireResponseId,
    expectedVersion: appointment.version,
    subject: source.subject,
    serviceProvider: source.serviceProvider,
    serviceLineId: source.serviceLineId,
    serviceLine: source.serviceLine,
    patientLocation: source.patientLocation,
    status: "in-progress-appointment",
    class: "NULL",
    participant: [{ individual: actor, period: { start: startedAt, end: null } }],
    period: { start: startedAt },
    statusHistory: [{ status: "in-progress-appointment", actor, period: { start: startedAt, end: null } }],
    intakeQuestions: {
      ...intake,
      intakeReason: booking.reason,
      callerNumber: booking.ext ? `${booking.phone} ext ${booking.ext}` : booking.phone,
      callerNumberExt: booking.ext,
      preferredChannel: booking.preferredChannel,
      ...(questionnaireResponseId ? { questionnaireResponseId } : {}),
    },
  };
  if (booking.preferredChannel === "video/chat") {
    payload.intakeQuestions.zoomTopic = `appt-${appointment.appointmentId}`;
    payload.intakeQuestions.zoomPassword = generatePass();
  }
  return payload;
}
